import { format } from 'date-fns/format';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCButton } from 'rollup-allspark';
import { isEmpty } from '../../../utils';
import {
  generatePerformanceCSVData,
  sortAggregatedDataRow,
} from '../../../utils/nativeAnalyticsUtils';
import { downloadCsvFromJSON } from '../../../utils/sheetUtils';
import { editField } from '../actions';
import { makeSelectProperty } from '../selectors';
import PerformanceTable from './PerformanceTable';

const BrandPerformance = ({ brandPerformanceData, updateField }) => {
  const { performanceRowData } = brandPerformanceData;

  const handleSortChange = (sortBy, sortOrder) => {
    const sortedPerformanceRowData = sortAggregatedDataRow(
      performanceRowData,
      sortBy,
      sortOrder,
    );
    updateField({
      brandPerformanceData: {
        ...brandPerformanceData,
        performanceRowData: sortedPerformanceRowData,
      },
    });
  };

  const handleCSVDownload = () => {
    const csvHeader = {
      name: 'Brand',
      net_sales: 'Gross Order Value',
      net_sales_cent: 'Gross Order Value (In Cent)',
      total_orders: 'Total Orders',
    };
    const CSVData = generatePerformanceCSVData(csvHeader, brandPerformanceData);

    downloadCsvFromJSON(
      CSVData,
      `brand-performance-${format(new Date(), 'yyyy-mm-dd hh:mm')}`,
    );
  };

  const downloadCSVButton = !isEmpty(performanceRowData) ? (
    <SCButton
      variant="secondary"
      size="sm"
      className="rounded-lg bg-grey-light text-black hover:bg-grey gap-x-1 w-auto flex items-center px-4 h-6 text-xs font-medium"
      action={handleCSVDownload}
    >
      <i className="kt-download" />
      <p>CSV</p>
    </SCButton>
  ) : null;

  return (
    <div className="flex flex-col gap-y-4">
      <div className="flex px-4 justify-end">{downloadCSVButton}</div>
      <PerformanceTable
        title="Brand"
        performanceData={brandPerformanceData}
        onSortChange={handleSortChange}
      />
    </div>
  );
};

BrandPerformance.propTypes = {
  brandPerformanceData: PropTypes.object,
  updateField: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  brandPerformanceData: makeSelectProperty('brandPerformanceData'),
});

const mapDispatchToProps = dispatch => ({
  updateField: params => dispatch(editField(params)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(BrandPerformance);
